import { ReactElement } from "react";
import { pageNames } from "./authConfig";
import EventIcon from "@mui/icons-material/Event";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import { Events } from "./Events/UI/Events";
import { Reports } from "./Reports/UI/Reports";
import { EventCreate } from "./Events/UI/EventCreate";
import EventJourney from "./Events/UI/EventJourney";
import HelpView from "./HelpPage/UI/HelpView";

export interface NavbarRoutes {
  name: string;
  icon: ReactElement | null;
  routerPath: string | null;
  control: ReactElement | null;
  roles: string[];
  isNavItem: boolean;
  isActivePage: boolean;
  order: number;
  children: NavbarRoutes[] | null;
}
export const getRoutes = (): NavbarRoutes[] => {
  return [
    {
      name: pageNames.events,
      icon: <EventIcon htmlColor="#FFFFFF" />,
      routerPath: "",
      control: <Events />,
      roles: [],
      isNavItem: true,
      isActivePage: true,
      order: 1,
      children: [
        {
          name: pageNames.eventCreate,
          icon: <InsertDriveFileIcon htmlColor="#FFFFFF" />,
          routerPath: "events/create",
          control: <EventCreate />,
          roles: [],
          isNavItem: false,
          isActivePage: true,
          order: 0,
          children: [],
        },
        {
          name: pageNames.eventJourney,
          icon: null,
          routerPath: "events/:eventId",
          control: <EventJourney />,
          roles: [],
          isNavItem: false,
          isActivePage: true,
          order: 0,
          children: [],
        },
      ],
    },
    {
      name: pageNames.reports,
      icon: <InsertDriveFileIcon htmlColor="#FFFFFF" />,
      routerPath: "reports",
      control: <Reports />,
      roles: [],
      isNavItem: true,
      isActivePage: true,
      order: 2,
      children: [],
    },
    {
      name: pageNames.helpPage,
      icon: <HelpCenterIcon htmlColor="#FFFFFF" />,
      routerPath: "help",
      control: <HelpView></HelpView>,
      roles: [],
      isNavItem: false,
      isActivePage: true,
      order: 0,
      children: null,
    },
  ];
};
